@if (visible()) {
  <div class="pwa-banner" role="region" [attr.aria-label]="'PWA_INSTALL.BANNER_LABEL' | translate">
    <div class="pwa-banner__inner">
      <div class="pwa-banner__text">
        <strong class="pwa-banner__title">{{ 'PWA_INSTALL.TITLE' | translate }}</strong>
        @if (iosMode()) {
          <p class="pwa-banner__desc">{{ 'PWA_INSTALL.IOS_INSTRUCTIONS' | translate }}</p>
          <img
            class="pwa-banner__illu"
            src="/pwa/ios-add-to-home.png"
            alt=""
            width="320"
            height="160"
            loading="lazy"
          />
        } @else if (nativeInstallAvailable()) {
          <p class="pwa-banner__desc">{{ 'PWA_INSTALL.ANDROID_HINT' | translate }}</p>
        } @else {
          <p class="pwa-banner__desc">{{ 'PWA_INSTALL.ANDROID_MANUAL' | translate }}</p>
        }
      </div>
      <div class="pwa-banner__actions">
        @if (nativeInstallAvailable()) {
          <button
            type="button"
            class="pwa-banner__btn pwa-banner__btn--primary"
            (click)="install()"
          >
            {{ 'PWA_INSTALL.INSTALL' | translate }}
          </button>
        }
        <button type="button" class="pwa-banner__btn pwa-banner__btn--ghost" (click)="dismiss()">
          {{ 'PWA_INSTALL.LATER' | translate }}
        </button>
      </div>
    </div>
  </div>
}
